<!-- //
右侧属性tab栏的位置属性
@auth xuyd
@date 2024-05-03
//-->
<template>
  <el-form @submit.native.prevent class="form" :model="form" :inline="true" size="mini">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item prop="width" label="">
          <el-input v-model="form.width" style="width: 100%" maxlength="6" placeholder="宽度">
            <div slot="append" style="width: 15px;text-align: center;">W</div>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item prop="height" label="">
          <el-input v-model="form.height" style="width: 100%" maxlength="6" placeholder="高度">
            <div slot="append" style="width: 15px;text-align: center;">H</div>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item prop="left" label="">
          <el-input v-model="form.left" style="width: 100%" maxlength="6" placeholder="左边距">
            <div slot="append" style="width: 15px;text-align: center;">X</div>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item prop="top" label="">
          <el-input v-model="form.top" style="width: 100%" maxlength="6" placeholder="上边距">
            <div slot="append" style="width: 15px;text-align: center;">Y</div>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item prop="aglin" label="位置">
          <el-input v-model="form.aglin" style="width: 100%" maxlength="6" placeholder="位置" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  name: 'PropsTabPosition',
  data() {
    return {
      form: this.viewProps, // widgetProps.viewProps
    }
  },
  props: {
    viewProps: {
      type: Object,
      default: () => {
        return {
          width: null,
          height: null,
          left: null,
          top: null,
        }
      }
    }
  },
  watch: {
    viewProps: {
      handler: function (val) {
        this.form = val;
      },
      immediate: false
    }
  },
}
</script>

<style lang="less" scoped>
</style>
